/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Annotation_ImpactInputs */



/**
* | output |
* | --- |
* | "Each annotation's before and after, against your usual swing" |
*
* @param {Pricing_Compare_Annotation_ImpactInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_annotation_impact = /** @type {((inputs?: Pricing_Compare_Annotation_ImpactInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Annotation_ImpactInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("До и после каждой аннотации на фоне обычных колебаний сервера")
	return /** @type {LocalizedString} */ ("Each annotation's before and after, against your usual swing")
});